import { HTMLAttributes } from 'react';
import { ContentPasteGoOutlined, Done } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useLocalTranslation } from '@jove-frontend/uikit';

type SwitchToJoveAlreadyInsuredElsewhereProps = HTMLAttributes<HTMLDivElement> & {
  topIconClassName?: string;
  featureIconClassName?: string;
};

const SwitchToJoveAlreadyInsuredElsewhere = (props: SwitchToJoveAlreadyInsuredElsewhereProps) => {
  const { className, topIconClassName, featureIconClassName } = props;
  const { $t } = useLocalTranslation();

  const features = [
    $t('page:alreadyInsuredElsewhere.feature_answer_questions'),
    $t('page:alreadyInsuredElsewhere.feature_docs_delivered'),
    $t('page:alreadyInsuredElsewhere.feature_flexible_payments'),
    $t('page:alreadyInsuredElsewhere.feature_worldwide_cover'),
    $t('page:alreadyInsuredElsewhere.feature_secure_renewal'),
    $t('page:alreadyInsuredElsewhere.feature_auto_activation'),
  ];

  return (
    <Box className={clsx('flex flex-col justify-center space-y-8', className)}>
      <Box className="flex flex-col">
        <Box className={clsx('bg-light-blue flex h-14 w-14 flex-row items-center justify-center space-x-1 rounded-full', topIconClassName)}>
          <ContentPasteGoOutlined className="text-brand-secondary h-8 w-8" />
        </Box>
        <Typography className="text-primary-black font-serif text-[52px] font-black leading-tight">{$t('page:alreadyInsuredElsewhere.title')}</Typography>
      </Box>
      <Box className="flex flex-col">
        <Typography variant="body1" className="text-primary-black font-medium leading-relaxed">
          {$t('page:alreadyInsuredElsewhere.description')}
        </Typography>
        <Typography variant="body1" className="text-primary-black font-medium leading-relaxed">
          {$t('page:alreadyInsuredElsewhere.switching_description')}
        </Typography>
      </Box>

      <Box className="flex flex-col space-y-2">
        {features.map((feature, index) => (
          <Box key={index} className="flex flex-row items-start space-x-4">
            <Box className={clsx('bg-light-blue flex h-8 w-8 items-center justify-center rounded-full', featureIconClassName)}>
              <Done className="text-brand-secondary h-5 w-5" />
            </Box>
            <Typography variant="h6" className="text-primary-black flex-1 font-bold">
              {feature}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SwitchToJoveAlreadyInsuredElsewhere;
